import { Injectable } from '@angular/core';
import { CdkDropList } from '@angular/cdk/drag-drop';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class EuiChipListDragService {

    public componentConnector: CdkDropList[] = [];
    public droppableArea: CdkDropList[] = [];
    public removedFromDroppable = new BehaviorSubject(null);

    public setComponentConnector(sourceName: string) {
        if (!this.componentConnector[sourceName]) {
            this.componentConnector[sourceName] = [];
        }
    }

    public setDroppableArea(componentRef: CdkDropList, sourceNames: string[]) {
        sourceNames.map((sourceName) => {
            if (!this.droppableArea[sourceName]) {
                this.droppableArea[sourceName] = [];
            }

            this.droppableArea[sourceName].push(componentRef);

            if (!this.componentConnector[sourceName]) {
                this.setComponentConnector(sourceName);
            }

            this.componentConnector[sourceName].push(componentRef);
        });
    }

    public removeFromDroppable(item: any | null) {
        this.removedFromDroppable.next(item);
    }

    public resetConnector() {
        this.componentConnector = [];
        this.droppableArea = [];
    }
}
